import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {NewDeletePinComponent} from "../new-delete-pin/new-delete-pin.component";
import {catchError} from "rxjs/operators";
import {throwError} from "rxjs";
import {SampleService} from "../../../services/sample.service";
import {NavBarComponent} from "../../../nav-bar/nav-bar.component";
import { DeleteSampleComponent } from '../../delete-sample/delete-sample.component';
import { AddEditSoilSampleComponent } from '../add-edit-soil-sample/add-edit-soil-sample.component';
import { SoilSampleModel } from 'src/app/models/soil-sample-model';
import dayjs from "dayjs";
import { is } from 'node_modules/cypress/types/bluebird';


@Component({
    selector: 'app-soil-pin-samples',
    templateUrl: './soil-pin-samples.component.html',
    styleUrls: ['./soil-pin-samples.component.css'],
    standalone: false
})
export class SoilPinSamplesComponent implements OnInit{

  samples:SoilSampleModel[] = [];

  tenantId = this.data.tenantId;
  userId = this.data.userId;

  isEditSampleMode:boolean = false;
  isAddNewSapleMode:boolean = false;

  dateStringFormatting = 'YYYY-MM-DD' + '  ' + 'hh:mm:ss'; 
  placeholder: string = "-";

  protected readonly dayjs = dayjs;

  pinObj = {
    pinTypeId: this.data.pinTypeId,
    date: this.data.date,
    lat: this.data.lat,
    lng: this.data.lng,
    farm: this.data.farm,
    field: this.data.field,
    fieldId: this.data.fieldId,
    creatingUser: this.data.creatingUser,
    pinId: this.data.pinId,
    pinDescription: this.data?.pinDescription,
    is_completed: this.data?.isCompleted
  };
  isGrid: boolean = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public deletePinDialog: MatDialog,
      public addSampleDialog: MatDialog,
      public closePinDialog: MatDialogRef<SoilPinSamplesComponent>,
      private sampleService: SampleService,
      public nav: NavBarComponent
  ) {
    this.closePinDialog.backdropClick().subscribe(() => {
      this.close();
    });
  }

  ngOnInit(): void {
    this.isGrid = this.data?.isGrid ?? false;
    this.nav.toggleLoading(true);
      this.populateSampleList();
      // this.nav.toggleLoading(false);
    }

  close(): void {
    if(this.samples?.length > 0) {
      this.pinObj.is_completed = this.samples.every(s => s?.isCompleted);
      this.checkSampleName(this.samples[0]?.name);
    } else {
      this.pinObj.is_completed = false;
      this.checkSampleName('');
    }
    
    this.closePinDialog.close(this.pinObj);
  }

  checkSampleName(sampleName: string) {
    if(sampleName.length > 0) {
      this.pinObj.pinDescription = sampleName;
    } else {
      this.pinObj.pinDescription = 'Soil';
    }
  }


  getGridBaseName(): string {
    const sorted = [...this.samples].sort((a, b) => new Date(a.creationDate).getTime() - new Date(b.creationDate).getTime());
    return sorted[0]?.name ?? "";
  }

  populateSampleList(){
    this.sampleService.getSoilSamplesListByPinId(this.pinObj.pinId).pipe(
        catchError(error =>{
          console.error();
          return throwError(()=> error);
        })
    ).subscribe((response) =>{
      //console.log(response);
      this.samples = response;
      this.nav.toggleLoading(false);
    })
   
  }

  openAddSampleDialog() {

  const dialogRef = this.addSampleDialog.open(AddEditSoilSampleComponent, {

    data:{
      pinId: this.pinObj.pinId,
      userId: this.userId,
      tenantId: this.tenantId,
      isAddNewSapleMode: true,
      isEditSampleMode: false,
      isGrid: this.isGrid,
      gridSampleName: this.isGrid && this.samples.length > 0 ? this.getGridBaseName() + " " + String.fromCharCode(66 + this.samples.length - 1) : "",
      linkedGroup: this.isGrid && this.samples.length > 0 ? this.samples[0].group?.id : null
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    setTimeout(()=>{
      this.populateSampleList();
    },500)
  });
 

  }

  openEditSampleDialog(sampleItem) {
    //console.log(sampleItem)
  const dialogRef = this.addSampleDialog.open(AddEditSoilSampleComponent, {

    data:{
      pinId: this.pinObj.pinId,
      userId: this.data.userId,
      tenantId: this.data.tenantId,
      isEditSampleMode:true,
      isAddNewSapleMode: false,
      sampleId: sampleItem.id,
      linkedGroup: sampleItem?.sampleGroup ? sampleItem.sampleGroup?.id : sampleItem.group?.id,
      sampleName: sampleItem.name,
      bagNumber: sampleItem.bagNumber,
      rockPercentage: sampleItem.soil.rockPercentage,
      sampleDepth: sampleItem.soil.sampleDepth,
      note: sampleItem.note === -1 ? '' : sampleItem.note,
      isCompleted: sampleItem.isCompleted,
      seasonFieldDetailId: sampleItem.seasonFieldDetailId
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    setTimeout(()=>{
      this.populateSampleList();
    },500)
  });


  }

  openDeleteSampleDialog(sampleItem) {

    const dialogRef = this.addSampleDialog.open(DeleteSampleComponent, {

      data:{
        sampleId: sampleItem.id,
        isBulkDelete: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      setTimeout(()=>{
        this.populateSampleList();
      },500)
    });

  }

  openDeletePinDialog() {

    const dialogRef = this.deletePinDialog.open(NewDeletePinComponent, {
      data: {
        pinId: this.pinObj.pinId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.option === 'delete'){
        this.closePinDialog.close();
       }
    });
  }

}
